import { render } from "./template.vue?vue&type=template&id=c790c26e&scoped=true"
const script = {}

import "./template.vue?vue&type=style&index=0&id=c790c26e&lang=scss&scoped=true"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c790c26e"]])

export default __exports__